<template>
<div
    v-if="value != null"
    style="position: relative;"
>
    <div 
        :class="{ 'label' : !center_label, 'center_label': center_label}"
    >
        {{value.internal_label}}
    </div>
    
    <table
        class="my_table"
    >
        <tr
            v-if="value.first_name != null && value.kind == 'individual'"
        >
            <td class="label_cell">First name</td>
            <td class="value_cell">{{value.first_name}}</td>
        </tr>

        <tr
            v-if="value.last_name != null && value.kind == 'individual'"
        >
            <td class="label_cell">Last name</td>
            <td class="value_cell">{{value.last_name}}</td>
        </tr>

        <tr
            v-for="(item, index) in value.organization_names"
            :key="'org_name'+index"
        >
            <td class="label_cell">Organization</td>
            <td class="value_cell">{{item}}</td>
        </tr>

        <tr
            v-for="(item, index) in value.phone_numbers"
            :key="'tn'+index"
        >
            <td class="label_cell">{{$rc.pretty(item.type, 'enum_red_chirp_vcard_telephone_type')}} Phone</td>
            <td class="value_cell">{{item.phone_number}}</td>
        </tr>

        <tr
            v-for="(item, index) in value.emails"
            :key="'email'+index"
        >
            <td class="label_cell">{{$rc.pretty(item.type, 'enum_red_chirp_vcard_email_type')}} Email</td>
            <td class="value_cell">{{item.email_address}}</td>
        </tr>

        <tr
            v-for="(item, index) in value.addresses"
            :key="'address'+index"
        >
            <td class="label_cell">{{$rc.pretty(item.type, 'enum_red_chirp_vcard_address_type')}} Address</td>
            <td class="value_cell" v-html="addressHTML(item)">

            </td>
        </tr>

        <tr
            v-for="(item, index) in value.notes"
            :key="'notes'+index"
        >
            <td class="label_cell">Note</td>
            <td class="value_cell">
                {{item}}
            </td>
        </tr>

    </table>

    <div
        style="position: absolute; top: 0px; right: 0px;"
        v-if="!readonly"
    >
        <v-menu 
            bottom 
            offset-y  
        >
        
        <template v-slot:activator="{ on }">
                
            <v-icon 
                v-on="on"
            >
                mdi-dots-vertical
            </v-icon>
                
        </template>
        
            <v-list>

                <v-list-item
                    v-on:click="onClickEdit()"
                >
                    <v-list-item-title>Edit...</v-list-item-title>
                </v-list-item>

                <v-list-item
                    v-on:click="onClickToggleArchive()"
                >
                    <v-list-item-title>{{toggle_archive_menu_item_text}}</v-list-item-title>
                </v-list-item>
            
            </v-list>
        
        </v-menu> 

        
    </div>

    <m-edit-vcard-dialog
        ref="edit-dialog"
        v-on:input="onEditVCard"
    />
</div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: function() { return null; }
        },

        readonly: {
            type: Boolean,
            default: function() { return false; }
        },

        center_label: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    methods: {
        addressHTML(address) {

            let lines = [];

            let pushLine = (value) => {
                if( value == null ) return;
                if ( value.trim().length == 0 ) return;

                lines.push(value.trim());
            }

            pushLine(address.address_one);
            pushLine(address.address_two);

            let locality_line = '';
            if ( address.city != null && address.city.trim().length != 0 )
                locality_line += address.city+", ";

            if ( address.state != null && address.state.trim().length != 0 )
                locality_line += address.state+" ";

            if ( address.zip != null && address.zip.trim().length != 0 )
                locality_line += address.zip;

            pushLine(locality_line);

            pushLine(address.country);

            return this.$rc.pretty(lines, 'br_list');
        },

        onClickEdit()
        {
            this.$refs['edit-dialog'].showDialog(this.value);
        },

        onEditVCard(item)
        {
            this.$emit('input',item);
        },

        onClickToggleArchive()
        {
            this.value.is_archived = !this.value.is_archived;

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/vcard',
            
                this.value,
            
                (data) => {
                    this.$rc.hideSpinner();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to update contact card');
                },
            );
        },
    },

    computed: {
        pretty_name() {

            if ( this.value.formatted_name != null )
                return this.value.formatted_name;

            if ( this.value.first_name != null || this.value.last_name != null )
            {
                let first_name = this.value.first_name;
                if ( first_name == null ) first_name = '';

                let last_name = this.value.last_name;
                if ( last_name == null ) last_name = '';

                return (first_name+' '+last_name).trim();
            }

            return null;
        },

        toggle_archive_menu_item_text() {
            if ( this.value == null || this.value.is_archived == false ) 
                return 'Archive';

            return 'Unarchive';
        },
    },
}
</script>

<style lang="scss" scoped>
.label
{
    font-weight: 700;
    font-size: 21px;
}

.center_label
{
    font-weight: 700;
    font-size: 16px;
    text-align: center;
}

.label_cell
{
    text-align: right;
    font-weight: bold;
    border-right: 1px solid rgba(0,0,0,0.3);

    padding-right: 5px;

    vertical-align: top;
    line-height: normal;
}

.value_cell
{
    padding-left: 5px;
}

.my_table {
    border:none;
    border-collapse: collapse;
    margin-top: 15px;
    margin-bottom: 15px;
}

</style>